import { useState } from 'react';
import { IUploaderFileResponse } from '../../types/components/uploader';

interface IUploaderDeleteButtonProps {
    file: IUploaderFileResponse;
    onDeleteClick: (id: string) => void;
}

function UploaderDeleteButton({ file, onDeleteClick }: IUploaderDeleteButtonProps) {
    const [deleting, setDeleting] = useState(false);

    const onDeleteClickHandler = async () => {
        setDeleting(true);
        await onDeleteClick(file.idFile);
        setDeleting(false);
    };

    return (
        <button type="button" className="btn btn-sm btn-outline-danger float-right" onClick={onDeleteClickHandler}>
            {!deleting && <i className="fa-solid fa-trash" />}
            {deleting && <div className="spinner-border spinner-border-sm" role="status" />}
        </button>
    );
}

export default UploaderDeleteButton;
